"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldsToSchema = void 0;
var fieldsToSchema_1 = require("./fieldsToSchema");
Object.defineProperty(exports, "fieldsToSchema", { enumerable: true, get: function () { return fieldsToSchema_1.fieldsToSchema; } });
